import React, { useEffect } from "react";

const GOOGLE_TAG_ID = "G-M5FQF9YL53";

export const GoogleTag: React.FC = () => {
	useEffect(() => {
		// Remove any existing Google Tag scripts
		const existingScripts = document.querySelectorAll(
			'script[src*="googletagmanager.com/gtag/js"]'
		);
		existingScripts.forEach((script) => script.remove());

		const existingInlineScripts = document.querySelectorAll(
			'script[data-google-tag="true"]'
		);
		existingInlineScripts.forEach((script) => script.remove());

		// Add async script tag for Google Tag
		const script = document.createElement("script");
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_ID}`;
		document.head.appendChild(script);

		// Add inline script for gtag configuration
		const inlineScript = document.createElement("script");
		inlineScript.setAttribute("data-google-tag", "true");
		inlineScript.textContent = `
			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());
			gtag('config', '${GOOGLE_TAG_ID}');
		`;
		document.head.appendChild(inlineScript);
	}, []);

	return null;
};
